<template>
  <div id="weezypictures">
    <div
      id="content"
      class="content"
    >
      <div class="content">
        <h1 class="page-title">
          <i class="fal fa-camera"></i> Photos Weezy
        </h1>
        <div
          class="info-button"
          @click.stop="$parent.toggleInfo"
        >
          <i class="fal fa-info-circle"></i> {{$parent.info_visible ? "Masquer les informations" : "Voir les informations"}} </div>
      </div>
      <div
        class="page-description"
        :class="{hidden: !$parent.info_visible}"
      >
        <b-message type="is-primary">
          <i class="fal fa-info-circle"></i>
          Retrouvez ici les photos prises sur <strong>Weezy</strong>
          <br>
        </b-message>
      </div>
    </div>

    <div class="content">
      <div
        class="wrapper mt2"
        v-if="pictures.length"
      >
        <div
          v-for="(picture, index) in pictures"
          :key="index"
          class="picture-container"
        >
          <img
            class="fit-picture"
            :src="`https://api.weezy.soda-armatis.com/static-files/WeezyPictures/${picture.name}.png`"
            alt="photo"
          >
          <button
            class="button button-delete is-danger is-small"
            id="clear"
            @click="deletePicture(picture)"
          >
            <span><i class="fal fa-times"></i> Supprimer</span>
          </button>
        </div>
      </div>
      <div
        class="mt2"
        v-else
      >
        Aucune photo disponible
      </div>
    </div>
  </div>
</template>

<script>
import gameScoresTable from "@/components/gameScoresTable";
import http from "@/modules/request";

export default {
  name: "weezypictures",
  components: {
    gameScoresTable
  },
  data() {
    return {
      pictures: []
    };
  },
  mounted() {
    this.getPictures();
  },
  methods: {
    getPictures() {
      http
        .get("/pictures")
        .then(response => {
          this.pictures = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    errorToast(message) {
      this.$toast.open({
        duration: 3000,
        message: message,
        position: "is-bottom",
        type: "is-danger"
      });
    },
    succesToast(message) {
      this.$toast.open({
        duration: 2000,
        message: message,
        position: "is-bottom",
        type: "is-success"
      });
    },

    deletePicture(picture) {
      http
        .post("/picture-delete/" + picture.id)
        .then(response => {
          this.pictures = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
}

.wrapper {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: auto auto auto auto;
  /* 4 auto means 4 columns */
}

.fit-picture {
  margin-bottom: -40px;
}

.button-delete {
  margin-left: calc(50% - 45px);
}

.button-delete {
  right: 0;
  top: 0px;
  opacity: 0;
}

.picture-container:hover .button-delete {
  opacity: 1;
}
</style>